//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { httpAction } from '@/api/manage';
import pick from 'lodash.pick';
import moment from 'moment';
export default {
  name: 'DayQualityControlModal',
  data: function data() {
    return {
      title: '操作',
      visible: false,
      model: {},
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 5
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      confirmLoading: false,
      form: this.$form.createForm(this),
      validatorRules: {},
      url: {
        add: '/om/day/quality/control/add',
        edit: '/om/day/quality/control/edit'
      }
    };
  },
  created: function created() {},
  methods: {
    add: function add() {
      this.edit({});
    },
    edit: function edit(record) {
      var _this = this;

      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;
      this.$nextTick(function () {
        _this.form.setFieldsValue(pick(_this.model, 'siteId', 'monitorProject', 'spanValue', 'zeroConcentration', 'spanConcentration', 'commitTime', 'userId', 'reviewedTime', 'reviewedBy', 'createBy', 'createTime', 'updateBy', 'updateTime', 'tenantId')); //时间格式化


        _this.form.setFieldsValue({
          commitTime: _this.model.commitTime ? moment(_this.model.commitTime) : null
        });

        _this.form.setFieldsValue({
          reviewedTime: _this.model.reviewedTime ? moment(_this.model.reviewedTime) : null
        });

        _this.form.setFieldsValue({
          createTime: _this.model.createTime ? moment(_this.model.createTime) : null
        });

        _this.form.setFieldsValue({
          updateTime: _this.model.updateTime ? moment(_this.model.updateTime) : null
        });
      });
    },
    close: function close() {
      this.$emit('close');
      this.visible = false;
    },
    handleOk: function handleOk() {
      var _this2 = this;

      var that = this; // 触发表单验证

      this.form.validateFields(function (err, values) {
        if (!err) {
          that.confirmLoading = true;
          var httpurl = '';
          var method = '';

          if (!_this2.model.id) {
            httpurl += _this2.url.add;
            method = 'post';
          } else {
            httpurl += _this2.url.edit;
            method = 'put';
          }

          var formData = Object.assign(_this2.model, values); //时间格式化

          formData.commitTime = formData.commitTime ? formData.commitTime.format('YYYY-MM-DD HH:mm:ss') : null;
          formData.reviewedTime = formData.reviewedTime ? formData.reviewedTime.format('YYYY-MM-DD HH:mm:ss') : null;
          formData.createTime = formData.createTime ? formData.createTime.format('YYYY-MM-DD HH:mm:ss') : null;
          formData.updateTime = formData.updateTime ? formData.updateTime.format('YYYY-MM-DD HH:mm:ss') : null;
          console.log(formData);
          httpAction(httpurl, formData, method).then(function (res) {
            if (res.success) {
              that.$message.success(res.message);
              that.$emit('ok');
              that.close();
            } else {
              that.$message.warning(res.message);
            }
          }).finally(function () {
            that.confirmLoading = false;
          });
        }
      });
    },
    handleCancel: function handleCancel() {
      this.close();
    }
  }
};